{{#items}}
  <li>
    <a>
      {{label}}
    </a>
  </li>
{{/items}}
